<div class="home-page">
    <div class="bg-color3 home-page-bg">
        <div class="content-width">
            <div class="flex-1 home-page-slide rightPane">
                <div class="claim-filter-section">
                    <ngb-accordion>
                        <ngb-panel title="Filter">
                            <ng-template ngbPanelHeader let-opened="opened">
                                <div class="d-flex align-items-center justify-content-between">
                                    <h5 class="accordion-header">
                                        {{ 'RegistrationApproval.Title' | translate }}</h5>
                                    <button ngbPanelToggle class="btn btn-link accordion">{{ opened ? '-' : '+'
                                        }}</button>
                                </div>

                            </ng-template>
                            <ng-template ngbPanelContent>
                                <p class="claimDescription">
                                    {{ 'RegistrationApproval.TitleBelow' | translate }}
                                </p>
                                <div class="grid grid-gap-40 grid-col-hd-50 grid-col-xs-100">
                                    <div class="margin-bottom-10">
                                        <form [formGroup]="userRegisterApprovalForm" #myform="ngForm">
                                            <p translate class="text-xlarge" id="headingPlaceOrder">{{ 'RegistrationApproval.Heading' | translate }}</p>
                                            <div class="row">
                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-6 col-lg-4 mt-4">
                                                            <label id="lblStatusType" translate>Status</label>
                                                            <div class="form-field">
                                                                <select name="statusType" id="idStatusType" formControlName="status" [ngModel]="statusValue" >
                                                                    <option [ngValue]="i.value" *ngFor="let i of statusList">{{i.name}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12 col-md-6 col-lg-4 mt-4">
                                                            <label id="lblUserName" translate>Mobile Number</label>
                                                            <div class="form-field">
                                                                <input type="text" id="idUserName" formControlName="mobileNumber" (ngModelChange)="SetMobileNumberValue($event)">
                                                                <div class="help-block text-danger"
                                                                     *ngIf="!userRegisterApprovalForm.controls.mobileNumber.valid">
                                                                    <span [hidden]="!userRegisterApprovalForm.controls['mobileNumber'].hasError('required')">* UserName is required</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
            
                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                    <div class="row">
                                                       
                                                    </div>
                                                </div>
                                            </div>
                    
                                        </form>
                                        <div class="col-sm-12 col-md-6 col-lg-4 mt-5">
                                            <button class="btn btn-primary customBtnSearch" (click)="FilterData()">
                                                {{ 'RegistrationApproval.Filter' | translate }}
                                                <a class="mobile-column-name">
                                                    <fa-icon [icon]="faAddIcon" class="addIcon"></fa-icon>
                                                </a>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </ng-template>
                        </ngb-panel>
                    </ngb-accordion>
                </div>
                <div class="claim-filter-section">
                    <div class="row" *ngIf="paginationDetails.totalNumberOfItems!==0">
                        <div class="col-12 col-md-7">
                            <p>
                                {{ 'TableRecords.FoundTotalOf' | translate }}{{paginationDetails.totalNumberOfItems}}{{'TableRecords.matches' | translate }}
                            </p>
                        </div>
                        <div class="col-12 col-md-2">
                            <div class="downloadList pull-right" (click)="downloadCSV()">
                                Download <span class="downloadIcons"></span>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="grid grid-col-xs-100 grid-col-hd-100 grid-gap-10">
                                <cs-items-per-page class="col-sm-6 text-right" style="max-width: 100%;" [paginationDetails]="paginationDetails"
                                                   (onChangeEvent)="onPaginationChange($event)">
                                </cs-items-per-page>
                            </div>
                        </div>
                    </div>
                    <div class="table-width" #dataLoading="appIsLoading" [appIsLoading]="loadingService.isLoading(this)">
                <table class="table table-striped" aria-describedby="Registration Approval"
                *ngIf="paginationDetails.totalNumberOfItems!==0">
                <thead>
                    <tr>
                        <th class="cm_12 cm_bold" role="button"   scope="col">
                            {{ 'RegistrationApproval.FirstName' | translate }}
                        </th>
                        <th class=" cm_12 cm_bold" role="button"  scope="col">
                            {{ 'RegistrationApproval.LastName' | translate }}
                        </th>
                        <th class="cm_12 cm_bold" role="button"  scope="col">
                            {{ 'RegistrationApproval.UserName' | translate }}
                        </th>
                        <th class="cm_12 cm_bold" role="button"  scope="col">
                            {{ 'RegistrationApproval.MobilePhoneNumber' | translate }}

                        </th>
                        <th class="cm_12 cm_bold" role="button"  scope="col">
                            {{ 'RegistrationApproval.CompanyName' | translate }}
                        </th>
                        <th class=" cm_12 cm_bold" role="button" scope="col">
                            {{ 'RegistrationApproval.PANNumber' | translate }}
                        </th>
                        <!--<th class=" cm_12 cm_bold" role="button" scope="col">
                            {{ 'RegistrationApproval.GST' | translate }}
                            
                        </th>-->
                        <th class=" cm_12 cm_bold" role="button" scope="col">
                            {{ 'RegistrationApproval.DateOfRegistration' | translate }}
                        </th>
                        <!--<th class=" cm_12 cm_bold" role="button"  scope="col">
                            {{ 'RegistrationApproval.RTO' | translate }}
                        </th>-->
                        <th class=" cm_12 cm_bold" role="button"  scope="col">
                            {{ 'RegistrationApproval.State' | translate }}
                            </th>
                        <!--<th scope="col">{{ 'RegistrationApproval.RegistrationStatus' | translate }}</th>-->
                        <th scope="col">{{ 'RegistrationApproval.JobRole' | translate }}</th>
                        <th scope="col">{{ 'RegistrationApproval.Approve' | translate }}</th>
                        <th scope="col">{{ 'RegistrationApproval.Reject' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let x of users; let y = index">
                        <td>{{x.firstName}}</td>
                        <td>{{x.lastName}}</td>
                        <td>{{x.userName}}</td>
                        <td>{{x.mobileNumber}}</td>
                        <td>{{x.companyName}}</td>
                        <td>{{x.panNumber}}</td>
                        <!--<td>{{x.gstNumber}}</td>-->
                        <td>{{x.dateofRegistration | date: 'dd MMM yyyy'}}</td>
                        <!--<td>{{x.rtoNo}}</td>-->
                        <td>{{x.state}}</td>
                        <!--<td>{{x.status}}</td>-->
                        <td>{{x.jobRole}}</td>
                        <td>
                            <a [class.disable]="DisableStatus(x.status)" (click)="UpdateStatus('Approved', x.userId, x.userName, x.status)">
                            <!--<fa-icon [icon]="faAddIcon"></fa-icon>--> Approve
                        </a>
                        </td>
                        <td>
                        <a [class.disable]="DisableStatus(x.status)" (click)="UpdateStatus('Rejected', x.userId, x.userName, x.status)">
                            <!--<fa-icon [icon]="faRemoveIcon"></fa-icon>-->Reject
                        </a>
                        </td>
                    </tr>

                </tbody>
                </table>
                    </div>
                    <div class="row" *ngIf="paginationDetails.totalNumberOfItems!==0">
                        <div class="col-lg-12 pagination-center-Bottom">
                            <cs-custom-pagination [paginationDetails]="paginationDetails" (onChangeEvent)="onPaginationChange($event)">
                            </cs-custom-pagination>
                        </div>
                    </div>
                </div>
            </div>
           <!-- Left side -->
           <div class="home-left leftPane">
            <!-- <cs-profile-point-card theme="theme-white" buttonTheme="theme2"></cs-profile-point-card>
            <cs-most-redeem-products [singleView]="true"></cs-most-redeem-products> -->
        </div>
            </div>
        </div>
    </div>

